import { Button } from '@material-ui/core';
import React from 'react';

const ModulesList = (props) => {
  const { moduleList, selectedModules, activeTab, handleAddModule } = props;

  return (
    <div className='d-flex flex-wrap justify-content-center'>
      {moduleList.map((item, i) => (
        <Button
          key={i}
          className='me-3 mb-2 module-select-btn'
          variant={
            selectedModules[activeTab].some((m) => m.module === item.key) ? 'contained' : 'outlined'
          }
          onClick={() => handleAddModule(item)}
          color={
            selectedModules[activeTab].some((m) => m.module === item.key) ? 'primary' : 'secondary'
          }
        >
          {item.value}
        </Button>
      ))}
    </div>
  );
};

export default ModulesList;
